import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useBlogsQuery } from 'services';
import Blog from 'components/Blog';
import { dataLimits } from 'constants';
import PaginationBox from 'components/PaginationBox';
import FilterForm from 'components/Blog/FilterForm';
import { buildBlogApiUrl } from 'utils';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

interface Filters {
	keyword: string;
	categoryId: string;
}

export const Blogs: React.FC = () => {
	const { translate } = useTranslate();
	const [currentPage, setCurrentPage] = useState(1);
	const [filters, setFilters] = useState<Filters>({ keyword: '', categoryId: '' });

	const { data, refetch } = useBlogsQuery(
		buildBlogApiUrl(currentPage, filters, dataLimits?.blogs.toString()),
	);
	const blogList = data?.data || [];
	const total = data?.meta?.pagination?.total || 0;

	useEffect(() => {
		refetch();
	}, [currentPage, filters]);

	const onApplyFilters = (keywordValue: string, categoryValue: string) => {
		setFilters({ keyword: keywordValue || '', categoryId: categoryValue || '' });
		setCurrentPage(1);
	};

	return (
		<section className="static-page bg-white">
			<Container>
				<div className="blogs py-50">
					<div className="blogs-header d-flex flex-column flex-lg-row align-items-lg-center gap-3 justify-content-between">
						<h3 className="fw-bold mb-0">{translate('Extras.blogs')}</h3>
						<div className="blogs-search d-flex flex-column flex-md-row gap-2 gap-md-3">
							<FilterForm onApplyFilters={onApplyFilters} />
						</div>
					</div>
					<div className="blogs-content">
						<Row className="blogs-content-row">
							{blogList.length > 0 ? (
								blogList.map((blog: any, index: number) => (
									<Col xl={4} md={6} key={index}>
										<Blog blog={blog} />
									</Col>
								))
							) : (
								<h6>{translate('Extras.noRecord')}</h6>
							)}
						</Row>
					</div>
					{total > dataLimits?.blogs && (
						<PaginationBox
							totalData={total}
							limit={dataLimits?.blogs}
							page={currentPage}
							setCurrentPage={setCurrentPage}
						/>
					)}
				</div>
			</Container>
		</section>
	);
};

export default Blogs;
